export const LIST_PAGE_1 = {
  meta: {
    count: 10,
    curr_page: 1,
    limit: 20,
    offset: 0,
    page_count: 3,
  },
  results: {
    objects: [
      {
        id: '11',
      },
      {
        id: '12',
      },
      {
        id: '13',
      },
      {
        id: '14',
      },
      {
        id: '15',
      },
      {
        id: '16',
      },
      {
        id: '17',
      },
      {
        id: '18',
      },
      {
        id: '19',
      },
      {
        id: '110',
      },
    ],
  },
}

export const LIST_PAGE_2 = {
  meta: {
    count: 10,
    curr_page: 2,
    limit: 20,
    offset: 0,
    page_count: 3,
  },
  results: {
    objects: [
      {
        id: '21',
      },
      {
        id: '22',
      },
      {
        id: '23',
      },
      {
        id: '24',
      },
      {
        id: '25',
      },
      {
        id: '26',
      },
      {
        id: '27',
      },
      {
        id: '28',
      },
      {
        id: '29',
      },
      {
        id: '210',
      },
    ],
  },
}

export const LIST_PAGE_3 = {
  meta: {
    count: 8,
    curr_page: 3,
    limit: 20,
    offset: 0,
    page_count: 3,
  },
  results: {
    objects: [
      {
        id: '31',
      },
      {
        id: '32',
      },
      {
        id: '33',
      },
      {
        id: '34',
      },
      {
        id: '35',
      },
      {
        id: '36',
      },
      {
        id: '37',
      },
      {
        id: '38',
      },
    ],
  },
}

export const PAGES = {
  1: LIST_PAGE_1,
  2: LIST_PAGE_2,
  3: LIST_PAGE_3,
}
